import React from 'react';
import { FacebookShareButton, XShareButton } from 'react-share';
import { useTranslation } from 'react-i18next';
import { Icon } from '@aqarmap/aqarmap-ui';
import Modal from '~/components/Modal';
import CopyButton from '~/components/CopyButton';
import Toggle from '~/components/Toggle';

const SharePropertiesModal = ({
  sharedFavoritesUrl,
  sharedNotesUrl,
}: {
  sharedFavoritesUrl: string | null;
  sharedNotesUrl: string | null;
}) => {
  const { t } = useTranslation('app');
  const [shareNotes, setShareNotes] = React.useState(false);

  return (
    <div className="[&>dialog>div]:!w-[375px]">
      <Modal title={t('sharePropertiesTitle')} modalKey="shareProperties">
        <div className="flex flex-col gap-2x !w-full">
          <div className="h-[48px] rounded-[8px] text-blue bg-blue_light_2 border border-blue_light_1 flex items-center gap-1.5x px-1.5x">
            <Icon name="circle-info" />
            <p className="text-gray__dark_1 text-body-2">
              {t('sharePropertiesInfo')}
            </p>
          </div>
          <div className="flex flex-col gap-y-2x w-full mt-x">
            <CopyButton
              text={shareNotes ? `${sharedNotesUrl}` : `${sharedFavoritesUrl}`}
            />
          </div>
          <div className="flex justify-between items-center">
            <p>{t('shareNotes')}</p>
            <Toggle
              onChange={(e) => {
                setShareNotes(e.target.checked);
              }}
              open={shareNotes}
            />
          </div>
          <div className="w-full flex flex-row gap-x-2x pb-3x pt-x">
            <div className="!border !border-gray rounded-[12px] flex-1">
              <FacebookShareButton
                url={shareNotes ? `${sharedNotesUrl}` : `${sharedFavoritesUrl}`}
                className="!border !border-gray rounded-[12px] flex items-center gap-1.5x !flex-1 !px-1.5x !py-2x !w-full"
                windowWidth={800}
              >
                <Icon name="facebook" />
                <span className="text-gray__dark_1">{t('facebook')}</span>
              </FacebookShareButton>
            </div>
            <div className="!border !border-gray rounded-[12px] flex-1">
              <XShareButton
                url={shareNotes ? `${sharedNotesUrl}` : `${sharedFavoritesUrl}`}
                className="!border !border-gray rounded-[12px] flex items-center gap-1.5x !flex-1 !px-1.5x !py-2x !w-full"
                windowWidth={800}
              >
                <Icon name="x-platform" />
                <span className="text-gray__dark_1">{t('twitter')}</span>
              </XShareButton>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default SharePropertiesModal;
